'use client';

import React, { useState, useEffect } from 'react';
import { loadPrefs, savePrefs, setConsented, needConsent, Cat, CatKey, initialCats } from '../utils/cookie-prefs';

declare global {
    interface Window {
        ym: any;
        [key: string]: any;
    }
}

const METRICA_ID = 105608540;

function loadYandexMetrika(id: number) {
    if (typeof window.ym === 'function') return;

    (function (m: any, e: Document, t: 'script', r: string, i: string) {
        m[i] = m[i] || function () { (m[i].a = m[i].a || []).push(arguments) };
        m[i].l = 1 * (new Date() as any);

        for (let j = 0; j < e.scripts.length; j++) {
            if (e.scripts[j].src === r) return;
        }

        const k = e.createElement(t) as HTMLScriptElement;
        const a = e.getElementsByTagName(t)[0];

        if (a && a.parentNode) {
            k.async = true;
            k.src = r;
            a.parentNode.insertBefore(k, a);
        }
    })(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

    const ymCall = window.ym as (...args: any[]) => void;
    ymCall(id, "init", {
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: true
    });
}

export function CookieGate() {
    const [cats, setCats] = useState<Cat[]>(initialCats);
    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
        setCats(loadPrefs());
        setShowBanner(needConsent());

        const prefsMap = Object.fromEntries(loadPrefs().map(c => [c.key, c.val]));
        if (prefsMap.analytics) {
            loadYandexMetrika(METRICA_ID);
        }
    }, []);

    const save = (mode?: 'all' | 'rej') => {
        let newCats = cats;
        if (mode === 'all') newCats = cats.map(c => ({ ...c, val: true }));
        if (mode === 'rej') newCats = cats.map(c => (c.lock ? c : { ...c, val: false }));

        setCats(newCats);
        savePrefs(newCats);
        setConsented();
        setShowBanner(false);

        const prefsMap = Object.fromEntries(newCats.map(c => [c.key, c.val]));
        if (prefsMap.analytics) {
            loadYandexMetrika(METRICA_ID);
        }
    };

    const acceptAll = () => save('all');
    const rejectAll = () => save('rej');

    if (!showBanner) return null;

    return (
        <div className="fixed left-0 right-0 bottom-0 z-50">
            <div className="mx-auto max-w-5xl m-3 rounded-2xl p-5" style={{ background: 'rgba(255,255,255,.08)', backdropFilter: 'blur(8px)' }}>
                <div className="md:flex md:items-center md:justify-between gap-4">
                    <p className="text-sm md:text-base text-gray-100">
                        Мы используем cookies для работы сайта, аналитики и персонализации. Узнайте больше в <a href="/cookies" className="underline font-semibold">Политике cookies</a>.
                    </p>
                    <div className="mt-3 md:mt-0 flex flex-wrap gap-3">
                        <button onClick={rejectAll} className="px-4 py-3 rounded-xl font-semibold" style={{ background: 'rgba(255,255,255,.1)' }}>Отклонить</button>
                        <button onClick={acceptAll} className="px-4 py-3 rounded-xl font-semibold" style={{ background: '#FFC300', color: '#102a43' }}>Принять всё</button>
                    </div>
                </div>
            </div>
        </div>
    );
}
